module.exports = __webpack_public_path__ + "img/hxsd_img1.ed451458.png";